import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-da-report',
  templateUrl: './da-report.component.html',
  styleUrls: ['./da-report.component.scss']
})
export class DaReportComponent implements OnInit {
  protected http: HttpClient;

  constructor(private route: ActivatedRoute, private cryptoJsService: CryptoJsService, private router: Router, private service: BaseService) { }


  items: any[];
  autoId: any;
  appId: any;
  selectedDate: any;
  date: any;
  activeItem: any;
  showTabs: boolean = false;
  path: any;
  userRole: any = null;

  ngOnInit() {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    this.userRole = tokenInfo['role'] ? tokenInfo['role'] : null;

    let parentRoute = this.router.url.split('/')[1];

    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        if(this.userRole == 'DMICADA'){
          this.router.navigate(['/department/report/da-report/mi']);
          this.items = [
            // { label: 'MI', routerLink: `/${parentRoute}/report/da-report/mi` },
            // { label: 'Pond', routerLink: `/${parentRoute}/report/da-report/pond` },
          ];
        }else if(this.userRole == 'DD-EW'){
          this.router.navigate(['/ew-department/report/da-report/pond']);
          this.items = [
            // { label: 'MI', routerLink: `/${parentRoute}/report/da-report/mi` },
            // { label: 'Pond', routerLink: `/${parentRoute}/report/da-report/pond` },
          ];
        }else if(this.userRole == 'DDMI'){
          this.router.navigate(['/department/report/da-report/mi']);
          this.items = [
            // { label: 'MI', routerLink: `/${parentRoute}/report/da-report/mi` },
            // { label: 'Pond', routerLink: `/${parentRoute}/report/da-report/pond` },
          ];
        }else{
          this.items = [
            { label: 'MI', routerLink: `/${parentRoute}/report/da-report/mi` },
            { label: 'Pond', routerLink: `/${parentRoute}/report/da-report/pond` },
          ];
        }
      }
      );
  }

  dateChange(){
  }

  submitHandler() {
    this.path = this.router.url.split('/')[4];
    // console.log(this.selectedDate,"selectedDate.........selectedDate")
    this.date = ((this.selectedDate.getMonth() > 8) ? (this.selectedDate.getMonth() + 1) : ('0' + (this.selectedDate.getMonth() + 1))) + '/' + ((this.selectedDate.getDate() > 9) ? this.selectedDate.getDate() : ('0' + this.selectedDate.getDate())) + '/' + this.selectedDate.getFullYear()
    // console.log(this.selectedDate,"selectedDate.........MM/DD/YYYY")
    this.service.changeDate(this.date)
    // this.showTabs=false;
    this.showTabs = true;
    
    this.navigateToReport();

    // if (this.path == 'mi') {
    //   let parentRoute = this.router.url.split('/')[1];

    //   if (parentRoute == 'ew-department') {
    //     this.router.navigate(['/ew-department/report/da-report/pond']);
    //   } else {
    //     this.router.navigate(['/department/report/da-report/mi']);
    //   }

    // }

    // else if (this.path == 'pond') {
    //   let parentRoute = this.router.url.split('/')[1];

    //   if (parentRoute == 'ew-department') {
    //     this.router.navigate(['/ew-department/report/da-report/mi']);
    //   } else {
    //     this.router.navigate(['/department/report/da-report/mi']);
    //   }
    // }
    // else {
    //   let parentRoute = this.router.url.split('/')[1];

    //   if (parentRoute == 'ew-department') {
    //     this.router.navigate(['/ew-department/report/da-report/mi']);
    //   } else {
    //     this.router.navigate(['/department/report/da-report/mi']);
    //   }
    // }

  }

  navigateToReport() {
    this.router.navigate(['/department/report/da-report']);
    
    if(this.userRole == 'DMICADA'){
      this.router.navigate(['/department/report/da-report/mi']);
    }else if(this.userRole == 'DD-EW'){
      this.router.navigate(['/ew-department/report/da-report/pond']);
    }else{
      let parentRoute = this.router.url.split('/')[1];
      if (parentRoute == 'ew-department') {
        this.router.navigate(['/ew-department/report/da-report/mi']);
      } else {
        this.router.navigate(['/department/report/da-report/mi']);
      }
    }
  }

  clearDate(){
    this.selectedDate = null;
    this.date = null;
    this.showTabs = false;
    this.service.changeDate(this.date)
    this.navigateToReport();
  }
  // onSelectedTable(event:any):{
  //  console.log(event,"event")
  // }

}
